export default {
  email: 'Email',
  role: 'Role',
  changeRoleTip:
    'After updating the information, users need to log in again to take effect. Are you sure you want to save?',
  userId: 'User ID',
  checkFormat: 'Please check the email format',
  checkNikeEmailFormat: 'Please enter the correct email address',
  deleteUserTip: 'Are you sure you want to delete the user permanently?',
  greyMarketAccess: 'Grey Market Access'
}
